import { FC, PropsWithChildren } from "react";

import { MainLayoutProps } from "./MainLayoutProps";

const MainLayout: FC<PropsWithChildren<MainLayoutProps>> = ({ children }) => {
  /**
   * Holds the top bar and the footer
   */
  return <>{children}</>;
};

export default MainLayout;
